import React from 'react'

function TenderTextIGMSB() {
  return (
    <embed src="\pdfs\EAT2.5.1.7_IG-M-SB_Induction_unit_for_mixing_ventilation_for_vertical_parapet_mounting_kr_01.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextIGMSB